const FILTERED_COLUMNS_KEY = 'filteredColumns'
const FILTERED_COLUMNS_OUTPUT_KEY = 'filteredOutputColumns'
const FILTERED_TYPE = {
  TABLE: 'table',
  PIVOT: 'pivot',
  OUTPUT_TABLE: 'output_table'
}

export {
  FILTERED_COLUMNS_KEY,
  FILTERED_COLUMNS_OUTPUT_KEY,
  FILTERED_TYPE as default
}
